import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Stack, useTheme } from "@mui/material";
import HourglassTopIcon from "@mui/icons-material/HourglassTop";
import CancelIcon from "@mui/icons-material/Cancel";

import Button from "components/basic/button";
import Typography from "components/basic/typography";

import { AttendeeStatus } from "../../../../types";
import { BookingResponseType } from "../../../../bookingsApi";

// Shown to a customer viewing their own pending appointment request (instead
// of the Accept / Decline invite actions, which make no sense for a booking
// they created themselves).
const OwnRequestNotice: React.FC<{
  myStatus?: AttendeeStatus;
  responding?: boolean;
  onRespond: (response: BookingResponseType) => void;
}> = ({ myStatus, responding, onRespond }) => {
  const theme = useTheme();
  const { t } = useTranslation("calendar");
  const cancelled = myStatus === "declined";

  return (
    <Box>
      <Typography variant="subtitle2" style={{ fontWeight: 600 }}>
        {t("details.your_request")}
      </Typography>
      <Stack
        direction="row"
        spacing={0.75}
        alignItems="center"
        sx={{ mt: 0.5 }}
      >
        <HourglassTopIcon
          sx={{
            fontSize: 16,
            color: cancelled
              ? theme.palette.text.disabled
              : theme.palette.warning.main,
          }}
        />
        <Typography
          variant="body2"
          style={{
            color: cancelled
              ? theme.palette.text.disabled
              : theme.palette.text.secondary,
          }}
        >
          {cancelled
            ? t("details.request_cancelled")
            : t("details.request_waiting")}
        </Typography>
      </Stack>

      {!cancelled && (
        <Stack spacing={1} sx={{ mt: 1.5 }}>
          <Button
            variant="outlined"
            color="error"
            fullWidth
            disabled={responding}
            startAdornment={<CancelIcon fontSize="small" />}
            onClick={() => onRespond("decline")}
          >
            {t("details.cancel_request")}
          </Button>
        </Stack>
      )}
    </Box>
  );
};

export default OwnRequestNotice;
